/* @ngInject */
export default function ExerciseShareWithTeamModalController(
  $uibModal,
  $uibModalInstance,
  config,
  submission,
) {
  const vm = Object.assign(this, {
    config,
    submission,
  });

  vm.submit = () => {
    // The modal chain relies on .result.finally() to sequence each step:
    // Points Modal → .finally() → Share to Workspace → .finally() → Submission Modal
    // Calling dismiss() here would trigger .finally() immediately, opening the
    // Submission Modal on top of the Share Submission dialog (the bug).
    // Instead, we hide this modal visually and defer dismiss() until the
    // Share Submission modal closes, preserving the correct sequencing.
    // TODO: Consider adding a condition-based approach in the dismiss/close flow
    // to handle chained modals more gracefully, avoiding the need to hide via DOM.
    const currentModalEl = document.querySelector('.points-modal');
    if (currentModalEl) {
      currentModalEl.style.display = 'none';
    }

    const shareModal = $uibModal.open({
      templateUrl: 'lecture_pages/templates/components/exercise-share-submission-modal.html',
      windowClass: 'large-modal',
      controller: 'ExerciseShareSubmissionModalCtrl as vm',
      resolve: {
        submission: vm.submission,
      },
    });

    shareModal.result.finally(() => {
      $uibModalInstance.dismiss();
    });
  };
}
